/** Slider arithmetic for the three volumes (04 §6: Master / Effects / Music). Pure. */

import type { Volumes } from './types';

const unit = (x: number): number => (Number.isFinite(x) ? Math.min(1, Math.max(0, x)) : 0);

/** A 0..1 slider as gain: squared, so the top of the range is not all the change; junk reads as 0. */
export function sliderGain(v: number): number {
  const c = unit(v);
  return c * c;
}

/** The same volumes with every slider inside 0..1. */
export function clampVolumes(v: Volumes): Volumes {
  return { master: unit(v.master), sfx: unit(v.sfx), music: unit(v.music) };
}
